// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[dir] .btn-group-toggle label.btn[data-v-3b998422]:not(.active) {\n  background-color: gray !important;\n}\n", ""]);
// Exports
module.exports = exports;
